import { IconLoaders } from './lazyIconRegistry'
import { createLazyAssetGetter } from '../lazyAssetRegistry'

/**
 * Lazily loads an icon component by its export name, e.g. for config-driven keys.
 *
 * Example:
 * const Icon = loadIconComponent(iconName)
 * return <Icon {...props} fallback={optionalFallbackComponent} />
 *
 * iconName must be a valid entry in IconLoaders.
 * An invalid iconName will eagerly throw an error in dev,
 * or render the fallback in production.
 */
export const loadIconComponent = createLazyAssetGetter('IconLoaders', IconLoaders)
